module.exports = __webpack_public_path__ + "img/u5651.0f706814.png";